<template>
  <!--邮箱下载链接页面--->
  <div id="emailDownload" class="back_colorWidth">
    <model v-if="showModel4" :title="'正在下载'" :minWidth="'60%'" :showClose="1" :onButton="0" v-on:on-cancel="showModel4 = false">
      <div class="pd_10_20">
        <div class="filrProgNum" style="margin: auto">
          <p class="d_flex">
            <span>{{ upName }}</span>
            <span class="colorGray9D9D9D">{{ uploadMdoel }}%</span>
          </p>
          <div class="m_t_5 m_b_5">
            <div :style="{'width': uploadMdoel + '%'}"></div>
          </div>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import avatar from '@/assets/loading.gif'
export default {
  name: 'emailDownload',
  data () {
    return {
      id: this.$route.query.id || localStorage.emailDownId || 0,
      formFileName: this.$route.query.filename || localStorage.emailDownFileName || '',
      showModel4: true,
      upName: '',
      uploadMdoel: '',
      pathList: this.$pathList
    }
  },
  created () {
    localStorage.emailDownId = this.$route.query.id
    localStorage.emailDownFileName = this.$route.query.filename
    if (this.id || localStorage.emailDownId) {
      this.confirmExport()
    }
  },
  methods: {
    confirmExport (item) {
      console.log(this.formFileName)
      let that = this
      let url = ''
      that.uploadMdoel = 0
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + '/api/Download/DownLoadFile?hisId=' + this.id
      xmlResquest.open('GET', url, true)
      xmlResquest.onprogress = function (e) {
        var percent = e.loaded / e.total
        that.uploadMdoel = parseInt(percent * 100)// progress 在data中定义的全局变量，显示的进度
        // console.log(that.uploadPercent)
        that.upName = decodeURIComponent(that.formFileName)
        that.showModel4 = true
      }
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            that.showModel4 = false
            window.localStorage.removeItem('emailDownId')
            window.localStorage.removeItem('emailDownFileName')
            that.$router.push(that.pathList[0])
            return
          }
        }
        var elink = document.createElement('a')
        elink.download = decodeURIComponent(that.formFileName)
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
        that.showModel4 = false
        window.localStorage.removeItem('emailDownId')
        window.localStorage.removeItem('emailDownFileName')
        that.$router.push(that.pathList[0])
      }
      xmlResquest.send()
    },
    // loading
    coverGif () {
      if (!document.getElementById('loadingGif')) {
        let dom = document.createElement('div')
        dom.id = 'loadingGif'
        let html = '<img src="' + avatar + '" height="144" width="192"/>'
        dom.innerHTML = html
        document.getElementById('app').appendChild(dom)
      }
    },
    disCover () {
      if (document.getElementById('loadingGif')) {
        document.getElementById('app').removeChild(document.getElementById('loadingGif'))
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/myDnload/emailDownload.vue